import React, { useState } from 'react';
import RestaurantRegistration from './RestaurantRegistration';
import ManagerLogin from './ManagerLogin';
import WaiterLogin from './WaiterLogin';

const AuthRouter = ({ onAuthSuccess }) => {
  const [currentView, setCurrentView] = useState('managerLogin'); // 'managerLogin', 'waiterLogin', 'register'

  const handleAuthSuccess = (authData) => {
    // Pass authentication data to parent component
    onAuthSuccess(authData);
  };

  const handleRegistrationSuccess = (registrationData) => {
    // After successful registration, show login
    alert(`Registration successful for ${registrationData.restaurant.name}!\nYou can now login with your credentials.`);
    setCurrentView('managerLogin');
  };

  // Render the appropriate component based on current view
  switch (currentView) {
    
    case 'waiterLogin':
      return (
        <WaiterLogin
          onSuccess={handleAuthSuccess}
          onSwitchToManager={() => setCurrentView('managerLogin')}
        />
      );
    
    case 'managerLogin':
    default:
      return (
        <ManagerLogin
          onSuccess={handleAuthSuccess}
          onSwitchToRegister={() => setCurrentView('register')}
          onSwitchToWaiter={() => setCurrentView('waiterLogin')}
        />
      );
  }
};

export default AuthRouter;
